import { callFinishStatus, detOnBoarding } from '../api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { RootState } from '../store';

interface OnboardingState {
	data: any; // store onboarding data
	loading: boolean; // loading state
	error: string | null; // error message
	onboardingToken: string | null;
	interviewId: string | null;
	detOAuthToken: string | null;
	finishStatusData: any;
}

const initialState: OnboardingState = {
	data: null,
	loading: false,
	error: null,
	onboardingToken: null,
	interviewId: null,
	detOAuthToken: null,
	finishStatusData: null,
};

export const startOnboarding = createAsyncThunk<
	any, // return type
	{ token: string; profileId: any; confirmationNo: string }, // argument type
	{ rejectValue: string } // type for rejectWithValue
>(
	'Profile/startOnboarding',
	async ({ token, profileId, confirmationNo }, thunkAPI) => {
		try {
			const response = await detOnBoarding(token, profileId, confirmationNo);

			if (!response || !response.data?.result) {
				return thunkAPI.rejectWithValue(
					response.data?.message || 'No data received from onboarding API'
				);
			}
			if (!response || !response.data) {
				return thunkAPI.rejectWithValue(
					response.data?.message || 'No data received from onboarding API'
				);
			}
			sessionStorage.setItem(
				'sessionData',
				JSON.stringify(response.data?.data?.token)
			);
			return response.data?.data; // success case
		} catch (error: any) {
			// You can handle axios / fetch error messages here
			const message =
				error?.response?.data?.message || error.message || 'Unknown error';
			return thunkAPI.rejectWithValue(message);
		}
	}
);

export const callFinishStatusThunk = createAsyncThunk<
	object,
	{ token: string; sessionToken: string; profileId: any },
	{ rejectValue: string }
>(
	'Profile/callFinishStatus',
	async ({ token, sessionToken, profileId }, thunkAPI) => {
		try {
			const response = await callFinishStatus(token, sessionToken, profileId);

			if (!response || !response.data) {
				return thunkAPI.rejectWithValue(
					'No data received from end session API'
				);
			}

			return response.data;
		} catch (error: any) {
			const message =
				error?.response?.data?.message || error.message || 'Unknown error';
			return thunkAPI.rejectWithValue(message);
		}
	}
);

const detSlice = createSlice({
	name: 'onboarding',
	initialState: initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(startOnboarding.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(startOnboarding.fulfilled, (state, action: any) => {
				state.loading = false;
				state.data = action.payload;
				state.onboardingToken = action.payload?.token || null;
				state.interviewId = action.payload?.interviewId || null;
			})
			.addCase(startOnboarding.rejected, (state, action: any) => {
				state.loading = false;
				state.data = null;
				state.onboardingToken = null;
				state.interviewId = null;
				state.error = action.payload || 'Failed to fetch onboarding';
			})
			.addCase(callFinishStatusThunk.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(callFinishStatusThunk.fulfilled, (state, action: any) => {
				state.loading = false;
				state.finishStatusData = action.payload?.data ?? action.payload;
			})
			.addCase(callFinishStatusThunk.rejected, (state, action: any) => {
				state.loading = false;
				state.error = action.payload || 'Failed to call finish status';
			});
	},
});
export const onboardingState = (state: RootState) => state.onboarding;
export default detSlice.reducer;
